module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-fit u-force-3d"
  }, [_c('div', {
    staticClass: "c-home-slide--5__container u-flex u-flex-ai--end u-relative u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--5__wrapper u-relative u-zindex--2 u-marg-x-auto u-flex u-flex-ai--end u-flex-jc--space-between u-fit-w"
  }, [_c('div', {
    staticClass: "c-home-slide--5__wrapper__content u-relative u-marg-l-w2of12 u-w6of12"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--5__wrapper__content__newlestter c-home-slide__element has-delay-2 u-marg-t-lg u-marg-t-sm@sm"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_c('app-input-email', {
    staticClass: "c-home-slide--5__wrapper__content__form-input u-relative u-marg-t-xs",
    attrs: {
      "label": "Your email",
      "label-for": "email"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--5__wrapper__social u-w4of12"
  }, [_c('a', {
    staticClass: "c-socials-links__get-in-touch c-home-slide__element has-delay-6 u-relative u-flex u-flex-ai--center u-flex-jc--start u-color--white",
    attrs: {
      "href": 'mailto:' + _vm.$root.content.global.social.mail,
      "target": "_blank",
      "rel": "nofollow noreferrer noopener"
    }
  }, [_c('div', {
    staticClass: "c-socials-links__get-in-touch__line u-relative u-block u-w1of2 u-bg--white u-opacity--20"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-socials-links__get-in-touch__link u-relative u-block u-w1of2 u-color--white u-uppercase t-fweight--bold",
    attrs: {
      "href": 'mailto:' + _vm.$root.content.global.social.mail
    }
  }, [_vm._v("Get in touch")])]), _vm._v(" "), _c('app-socials-links', {
    staticClass: "c-home-slide__element has-delay-7 u-uppercase t-fweight--semi-bold t-fsize--xs",
    attrs: {
      "activeIndex": _vm.activeIndex
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--5__border c-home-slide__element has-delay-3 u-absolute u-pos-tr u-fit-h u-bg--brand-primary"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "c-home-slide--5__wrapper__content__title c-home-slide__element has-delay-0 u-marg-t-sm@sm t-ffamily--neue t-fweight--light u-color--white u-lheight--125p u-force-3d"
  }, [_c('div', {
    staticClass: "c-home-slide--5__wrapper__content__title--1 u-relative"
  }, [_vm._v("Ready, set,")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--5__wrapper__content__title--2 u-relative"
  }, [_vm._v("map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--5__wrapper__content__description c-home-slide__element has-delay-1 o-content u-relative u-color--white u-lheight--150p"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--60"
  }, [_vm._v("We cannot map the world alone. Sign-up and we'll keep you involved every step of the way as PRAX helps us build a new dimension.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c22b67c"}!./src/scripts/components/app-home-slide-5/template.html
// module id = 462
// module chunks = 0